export function AutoUnsubscribe(blackList: any = []) {
  return function (constructor: any) {
    constructor.prototype.ngOnDestroy = function () {
      // tslint:disable-next-line:forin
      for (const prop in this) {
        let property = this[prop];
        if (!blackList.includes(prop)) {
          if (property && typeof property.unsubscribe === 'function') {
            property.unsubscribe();
            property = null;
          } else if (prop != 'subscriptions') {
            this[prop] = null;
          }
        }
      }
    };
  };
}
